import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import NavigationBar from "../layout/NavigationBar";
import Footer from "../layout/footer";
import 'datatables.net-dt/css/jquery.dataTables.css';
import $ from 'jquery';
import 'datatables.net';

function Category() {
    const navigate = useNavigate();
    const [categoryData, setCategoryData] = useState([]);
    const [deleteCategoryId, setDeleteCategoryId] = useState("");
    const [deleteTitle, setDeleteTitle] = useState("");
    const [dataTable, setDataTable] = useState(null);

    // Edit modal states
    const [editCategoryId, setEditCategoryId] = useState("");
    const [editCategory, setEditCategory] = useState("");
    const [editSubcategory, setEditSubcategory] = useState("");
    const [editType, setEditType] = useState("");
    const [editColumnHeader, setEditColumnHeader] = useState("");
    const [editColumnPriority, setEditColumnPriority] = useState("");
    const [editIsFeatured, setEditIsFeatured] = useState(false);
    const [editIsTrending, setEditIsTrending] = useState(false);
    const [editDisplayOrder, setEditDisplayOrder] = useState("");

    useEffect(() => {
        // Fetch the data from the API on component mount
        fetchData();
    }, []);

    useEffect(() => {
        // Initialize DataTable if categoryData is available
        if (categoryData.length) {
            if (dataTable) {
                dataTable.destroy();
            }
            const table = $('#category').DataTable({
                data: categoryData,
                columns: [
                    { data: null, render: (data, type, row, meta) => meta.row + 1 }, // S.No
                    { data: 'category' }, // Category
                    { data: 'subcategory' }, // Subcategory
                    {
                        data: 'created_date',
                        render: (data) => new Date(data).toLocaleString()
                    }, // Date Added
                    {
                        data: null,
                        render: (data) => {
                            return `
                                <div align="center">
                                    <a href="#" class="crsr_pntr edit-btn mr-2" data-id="${data._id}" data-category="${data.category}" data-subcategory="${data.subcategory}" data-type="${data.type || ''}" data-column-header="${data.column_header || ''}" data-column-priority="${data.column_priority || ''}" data-is-featured="${data.is_featured || false}" data-is-trending="${data.is_trending || false}" data-display-order="${data.display_order || ''}" data-toggle="modal" data-target="#modaledit"><i class="fa-solid fa-pen"></i></a>
                                    <a href="#" class="crsr_pntr delete-btn" data-id="${data._id}" data-name="${data.category}" data-toggle="modal" data-target="#modaldelete"><i class="fa-solid fa-trash-can"></i></a>
                                </div>
                            `;
                        } // Action buttons (edit and delete)
                    }
                ],
                pageLength: 10,
                lengthMenu: [5, 10, 25, 50, 75, 100]
            });
            setDataTable(table);

            // Event listener for the edit button
            $('#category').on('click', '.edit-btn', function () {
                const categoryId = $(this).data('id');
                const category = $(this).data('category');
                const subcategory = $(this).data('subcategory');
                const type = $(this).data('type');
                const columnHeader = $(this).data('column-header');
                const columnPriority = $(this).data('column-priority');
                const isFeatured = $(this).data('is-featured');
                const isTrending = $(this).data('is-trending');
                const displayOrder = $(this).data('display-order');

                openEditModal(categoryId, category, subcategory, type, columnHeader, columnPriority, isFeatured, isTrending, displayOrder);
            });

            // Event listener for the delete button
            $('#category').on('click', '.delete-btn', function () {
                const categoryId = $(this).data('id');
                const categoryName = $(this).data('name');
                openDeleteModal(categoryId, categoryName);
            });
        }
    }, [categoryData]);

    const fetchData = () => {
        // Fetching category data from the server
        axios
            .get(process.env.REACT_APP_APIURL + "category/list?limit=100000")
            .then((res) => {
                if (res.data.status === "success") {
                    setCategoryData(res.data.result);
                }
            })
            .catch((err) => {
                console.error("Error fetching category data:", err);
            });
    };

    const deleteCategory = (category_id) => {
        // Delete a category from the server
        axios
            .post(`${process.env.REACT_APP_APIURL}category/delete`, { category_id: category_id, category_status: "delete" })
            .then((res) => {
                if (res.data.status === "success") {
                    // Remove the deleted category from the categoryData state
                    setCategoryData(categoryData.filter(category => category._id !== category_id));
                }
            })
            .catch((err) => {
                console.error("Error deleting category:", err);
            });
    };

    const updateCategory = () => {
        // Update category on the server
        const updateData = {
            category_id: editCategoryId,
            category: editCategory,
            subcategory: editSubcategory,
            type: editType,
            column_header: editColumnHeader,
            column_priority: editColumnPriority,
            is_featured: editIsFeatured,
            is_trending: editIsTrending,
            display_order: editDisplayOrder
        };

        axios
            .post(`${process.env.REACT_APP_APIURL}category/update`, updateData)
            .then((res) => {
                console.log("res check", res);
                if (res.data.status === "success") {
                    // Update the categoryData state with the updated category
                    setCategoryData(categoryData.map(category =>
                        category._id === editCategoryId
                            ? {
                                ...category,
                                category: editCategory,
                                subcategory: editSubcategory,
                                type: editType,
                                column_header: editColumnHeader,
                                column_priority: editColumnPriority,
                                is_featured: editIsFeatured,
                                is_trending: editIsTrending,
                                display_order: editDisplayOrder
                            }
                            : category
                    ));
                             // Clear the form
                    clearEditForm();
 const modal = document.getElementById('modaledit');
                if (modal) {
                    modal.style.display = 'none';
                    modal.classList.remove('show');
                    document.body.classList.remove('modal-open');
                    // Remove backdrop if exists
                    const backdrop = document.querySelector('.modal-backdrop');
                    if (backdrop) {
                        backdrop.remove();
                    }
                }
                    // Show success message (optional)
                    alert("Category updated successfully!");

                }
            })
            .catch((err) => {
                console.error("Error updating category:", err);
                alert("Error updating category. Please try again.");
            });
    };

    const openDeleteModal = (id, title) => {
        // Open the delete confirmation modal
        setDeleteCategoryId(id);
        setDeleteTitle(title);
    };

    const openEditModal = (id, category, subcategory, type, columnHeader, columnPriority, isFeatured, isTrending, displayOrder) => {
        // Open the edit modal with pre-filled data
        setEditCategoryId(id);
        setEditCategory(category);
        setEditSubcategory(subcategory);
        setEditType(type);
        setEditColumnHeader(columnHeader);
        setEditColumnPriority(columnPriority);
        setEditIsFeatured(isFeatured);
        setEditIsTrending(isTrending);
        setEditDisplayOrder(displayOrder);
    };

    const clearEditForm = () => {
        // Clear all edit form states
        setEditCategoryId("");
        setEditCategory("");
        setEditSubcategory("");
        setEditType("");
        setEditColumnHeader("");
        setEditColumnPriority("");
        setEditIsFeatured(false);
        setEditIsTrending(false);
        setEditDisplayOrder("");
    };

    return (
        <div className="wrapper" id="root">
            <header>
                <NavigationBar />
            </header>

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 txt_lft">Category
                                    <a href="/category_add">
                                        <i className="fa-solid fa-square-plus ml-2" title="Add Product" />
                                    </a>
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="table-responsive">
                                    <table id="category" className="table table-striped table-bordered txt_lft" style={{ width: '100%' }}>
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Category</th>
                                                <th>SubCategory</th>
                                                <th>Added On</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />

            {/* Edit Modal */}
            <div className="modal fade" id="modaledit" tabIndex={-1} aria-labelledby="modaleditLabel" aria-hidden="true" data-backdrop="static">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="modaleditLabel">Edit Category</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={clearEditForm}>
                                <i className="fa-solid fa-xmark" />
                            </button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="editCategoryName">Category Name <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="editCategoryName"
                                                value={editCategory}
                                                onChange={(e) => setEditCategory(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="editSubcategoryName">Subcategory Name <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="editSubcategoryName"
                                                value={editSubcategory}
                                                onChange={(e) => setEditSubcategory(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="editType">Type <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="editType"
                                                value={editType}
                                                onChange={(e) => setEditType(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="editColumnHeader">Column Header</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="editColumnHeader"
                                                value={editColumnHeader}
                                                onChange={(e) => setEditColumnHeader(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="editColumnPriority">Column Priority</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                id="editColumnPriority"
                                                value={editColumnPriority}
                                                onChange={(e) => setEditColumnPriority(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="editDisplayOrder">Display Order</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                id="editDisplayOrder"
                                                value={editDisplayOrder}
                                                onChange={(e) => setEditDisplayOrder(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="editIsFeatured"
                                                    checked={editIsFeatured}
                                                    onChange={(e) => setEditIsFeatured(e.target.checked)}
                                                />
                                                <label className="form-check-label" htmlFor="editIsFeatured">
                                                    Is Featured
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="editIsTrending"
                                                    checked={editIsTrending}
                                                    onChange={(e) => setEditIsTrending(e.target.checked)}
                                                />
                                                <label className="form-check-label" htmlFor="editIsTrending">
                                                    Is Trending
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer justify-content-center">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={updateCategory}
                            >
                                Update Category
                            </button>
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-dismiss="modal"
                                onClick={clearEditForm}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Delete Confirmation Modal */}
            <div className="modal fade" id="modaldelete" tabIndex={-1} aria-labelledby="modaldeleteLabel" aria-hidden="true" data-backdrop="static">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="modaldeleteLabel">Delete Category</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <i className="fa-solid fa-xmark" />
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="w-100 d-inline-block text-center">
                                Are you sure you want to delete <br /><span className="fwt_600">{deleteTitle}</span>?
                            </div>
                        </div>
                        <div className="modal-footer justify-content-center">
                            <button
                                type="button"
                                className="btn btn-primary"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={() => deleteCategory(deleteCategoryId)}
                            >
                                Yes, delete
                            </button>
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                No, cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Category;